import { notEmpty } from '@mahawi/eshop-common/dist/src/not-empty';
import {
  type ILanguageType,
  type ITranslation,
} from '@mahawi/eshop-common/dist/src/types';
import { type ILanguageState } from 'customer/react/reducers/language/types';
import { type IProductState } from 'customer/react/reducers/product/types';
import React, { type ReactElement, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';

function LanguageMutationLinks({
  Language,
  Product,
}: {
  Language: ILanguageState;
  Product: IProductState;
}): React.JSX.Element | null {
  const { t } = useTranslation();

  const links = useMemo((): ReactElement[] => {
    return Language.languages
      .map(({ code }: ILanguageType): React.JSX.Element | undefined => {
        const productName: ITranslation | undefined =
          Product.product?.names.find(
            (name: ITranslation): boolean => name.code === code,
          );

        let text: string = `(${code})`;

        if (productName) {
          text = `${text} ${productName.value}`;
        }

        let productLink: string = '';

        const slug: ITranslation | undefined = Product.product?.slugs.find(
          (s: ITranslation): boolean => s.code === code,
        );

        if (slug && slug.value) {
          productLink = `/${code.toLowerCase()}/p/${slug.value}`;
        } else if (Product.product?.uuid) {
          productLink = `/${code.toLowerCase()}/product/${Product.product?.uuid}`;
        }

        if (!productLink) {
          return;
        }

        return (
          <a key={code} href={productLink} hrefLang={code.toLowerCase()}>
            {text}
          </a>
        );
      })
      .filter(notEmpty);
  }, [Language.languages, Product.product]);

  if (!links.length) {
    return null;
  }

  return (
    <nav
      className="product container language-mutations"
      aria-label={t('layout.language')}
    >
      <h2>{t('layout.language')}</h2>
      {links}
    </nav>
  );
}

const mapStateToProps = ({ Language, Product }) => ({ Language, Product });

export default connect(mapStateToProps)(React.memo(LanguageMutationLinks));
